import { render, staticRenderFns } from "./GateEntryLogsModal.vue?vue&type=template&id=90a9fbd6&scoped=true&"
import script from "./GateEntryLogsModal.vue?vue&type=script&lang=js&"
export * from "./GateEntryLogsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a9fbd6",
  null
  
)

export default component.exports